export const urlToPathname = (urlString: string, { preserveQueryParams = false } = {}): string => {
  if (!urlString) {
    return '';
  }
  const prefixedUrlString = urlString.startsWith('/') ? urlString : `/${urlString}`;
  const urlToUse = urlString.startsWith('http') ? urlString : `https://domain.com${prefixedUrlString}`;
  const parsedUrl: URL =
    typeof window === 'undefined' && typeof global !== 'undefined' && typeof global.URL !== 'undefined'
      ? new global.URL(urlToUse)
      : new URL(urlToUse);

  if (preserveQueryParams) {
    return parsedUrl.pathname + parsedUrl.search + (parsedUrl.hash ? parsedUrl.hash : '');
  } else {
    return parsedUrl.pathname + (parsedUrl.hash ? parsedUrl.hash : '');
  }
};
